<div class="hoot-main ">
  <div class="header">
    <img src="assets/logomain.png" alt="buhonest" class="logo" />
  </div>

<router-outlet></router-outlet>
</div>